import { DataContextActionProps, DataState } from "types/data";
import { SET_NOTIFICATIONS } from "./actions";

// initial state
export const initialState: DataState = {
  notifications: [],
};

// ==============================|| DATA REDUCER ||============================== //

const dataReducer = (
  state = initialState,
  action: DataContextActionProps
): DataState => {
  switch (action.type) {
    case SET_NOTIFICATIONS: {
      return {
        ...state,
        notifications: action.payload?.notifications!,
      };
    }

    default: {
      return state;
    }
  }
};

export default dataReducer;
